import { RunStatus as GraphQLRunStatus } from "../../services/__generated__/graphql";
import { RunStatus } from "../../services/appsync/types";

export const WORKFLOW_ID = "workflow_atomic_pivots";
export const WORKFLOW_SHIPMENT_EDITS_ID = "workflow_shipment_edits";

/** Maps backend gateway RunStatus (PascalCase keys) to AppSync RunStatus (UPPER_SNAKE keys). */
export const BACKEND_STATUS_TO_APPSYNC: Record<GraphQLRunStatus, RunStatus> = {
  [GraphQLRunStatus.CancelCompleted]: RunStatus.CANCEL_COMPLETED,
  [GraphQLRunStatus.CancelFailed]: RunStatus.CANCEL_FAILED,
  [GraphQLRunStatus.CancelInProgress]: RunStatus.CANCEL_IN_PROGRESS,
  [GraphQLRunStatus.RunCompleted]: RunStatus.RUN_COMPLETED,
  [GraphQLRunStatus.RunFailed]: RunStatus.RUN_FAILED,
  [GraphQLRunStatus.RunInProgress]: RunStatus.RUN_IN_PROGRESS,
  [GraphQLRunStatus.RunTransformsRunning]: RunStatus.RUN_TRANSFORMS_RUNNING,
  [GraphQLRunStatus.ToRun]: RunStatus.TO_RUN,
};

export function mapBackendRunStatus(backendStatus: GraphQLRunStatus): RunStatus {
  const mapped = BACKEND_STATUS_TO_APPSYNC[backendStatus];
  if (!mapped) {
    console.warn("Unknown run status from backend gateway:", backendStatus);
    return RunStatus.RUN_FAILED;
  }
  return mapped;
}
